import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import checkUserPermission from "helpers/check-user-permission";
import MenuItems from "views/layout/menu-items";

const PrivateRoute = ({ component: Component, auth, match, ...rest }) => {
    // console.error("PrivateRoute", auth.user.role, rest);
    // todo when @michael complete with auth string to array task
    if (!Array.isArray(auth.user.role)) {
        auth.user.role = [auth.user.role];
    }
    const hasPermission = checkUserPermission(MenuItems, rest.location.pathname, auth.user.role);
    return (
        <Route
            {...rest}
            render={props => (
                Array.isArray(auth.user.role) && hasPermission
                    ? <Component linkParams={match} {...props} />
                    : <Redirect to="/permission-error" />
            )}
        />
    );
};
PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js